module.exports = __webpack_public_path__ + "static/media/p1a4.b34724da.wav";